import Vue from 'vue'
import Vuex from 'vuex'

import home from '@/modules/home/store'
import clube from '@/modules/clube/store'
import usuarios from '@/modules/usuarios/store'
import mobileBanners from '@/modules/mobile/banners/store'
import produtos from '@/modules/produtos/store'
import empresa from '@/modules/empresa/store'
import dre from '@/modules/empresa/dre/store'
import clientes from '@/modules/clientes/store'
import campanhas from '@/modules/campanhas/store'
import mariaCampanha from '@/modules/maria/campanha-da-maria/store'
import produtosImpulsionadores from '@/modules/maria/produtos-impulsionadores/store'
import analiseRfv from '@/modules/clientes/rfv/store'
import coupomDiscount from '@/modules/campanhas/cupom-desconto/store'
import sorteio from '@/modules/mobile/sorteio/store'
import segmentation from '@/modules/clientes/segmentation/store'
import calendarioPromocional from '@/modules/calendario-promocional/store'
import destaques from '@/modules/mobile/destaques/store'
import geo from '@/store/modules/geo'
import departments from '@/store/modules/departments'
import units from '@/store/modules/units'
import platformNotifications from '@/store/modules/platform-notifications'
import reviews from '@/store/modules/reviews'
import mobileOffers from '@/store/modules/mobile-offers'
import industry from '@/store/modules/industry'
import hub from '@/modules/gerenciador-analises/store'
import mariav2 from '@/modules/maria/campanha-da-maria-v2/store'
import hotsiteConfiguration from '@/modules/configuracoes/site-de-cadastramento/store'
import actions from '@/store/actions.js'
import getters from '@/store/getters.js'
import mutations from '@/store/mutations.js'
import state from '@/store/state.js'

Vue.use(Vuex)

export default new Vuex.Store({
  actions,
  getters,
  mutations,
  state,
  modules: {
    home,
    clube,
    produtos,
    empresa,
    clientes,
    campanhas,
    mariaCampanha,
    produtosImpulsionadores,
    analiseRfv,
    geo,
    departments,
    units,
    platformNotifications,
    reviews,
    segmentation,
    mobileOffers,
    calendarioPromocional,
    usuarios,
    mobileBanners,
    sorteio,
    coupomDiscount,
    destaques,
    dre,
    industry,
    hub,
    mariav2,
    hotsiteConfiguration,
  },
})
